module.exports = __webpack_public_path__ + "static/media/rugrats-post-game-hoodie.783d99c7.png";